const FILENAME_STAR_PATTERN = /filename\*=\s*(?:UTF-8|utf-8)''([^;]+)/;
const FILENAME_PATTERN = /filename="([^"]*)"|filename=\s*([^;]+)/;

/**
 * Reads the file name out of a `Content-Disposition` header.
 *
 * `filename*` wins over the ASCII `filename` because it is the only one of the
 * two that survives a non-ASCII character: the backend replaces those with `_`
 * in the ASCII parameter. On the certificate routes both arrive equal, since
 * the name is already built without diacritics, so the preference is robustness
 * for any other route rather than a fix for this one.
 *
 * @param header - Response header, when it came
 * @returns The file name, or `null` when the header does not name a file
 */
export function parseContentDispositionFilename(header: string | null | undefined): string | null {
  if (!header) return null;

  const encodedMatch = FILENAME_STAR_PATTERN.exec(header);

  if (encodedMatch?.[1]) {
    try {
      return decodeURIComponent(encodedMatch[1].trim());
    } catch {
      return encodedMatch[1].trim();
    }
  }

  const plainMatch = FILENAME_PATTERN.exec(header);
  const plainFilename = (plainMatch?.[1] ?? plainMatch?.[2])?.trim();

  return plainFilename ? plainFilename : null;
}

export default parseContentDispositionFilename;
